// chartUtils.ts
export const toNum = (v: any) =>
  typeof v === 'string' ? Number(v.replace(/,/g, '')) : Number(v) || 0;

export const axisMaxByMSD = (n: number) => {
  if (!isFinite(n) || n <= 0) return 1;
  const d = Math.floor(Math.log10(Math.floor(n))) + 1;
  const msd = Math.floor(n / 10 ** (d - 1));
  return (msd + 1) * 10 ** (d - 1);
};

export const makeStack = (data: any[]) =>
  data.map((d) => {
    const p = toNum(d.progress);
    const w = Math.max(0, toNum(d.wonCount));
    const wonCountCapped = Math.min(w, p);
    const progressRemainder = Math.max(0, p - wonCountCapped);
    return { ...d, wonCountCapped, progressRemainder };
  });
